"use strict";

require("react-union-polyfills/ie9");

require("react-union-polyfills");